export const isExtension = (value: string) => {
  return /^.*\.\w+$/.test(value);
};
